import { useEffect, useState } from 'react';
import { QuickReply } from '@connect-x-app/shared-domain-models';

import { useQuickReplyTable } from '../../../../shared/hooks/useQuickReplyTable';
import { IndexableQuickReply } from '../../../../shared/models/indexableQuickReply';
import { mapQuickRepliesToIndexableQuickReplies } from '../../../../shared/utils/indexableQuickReplyMapper.util';
import { useCreateQuickReplies } from '../queries/useCreateQuickReplies';
import { useDeleteQuickReplies } from '../queries/useDeleteQuickReplies';
import { useQuickReplies } from '../queries/useQuickReplies';
import { useUpdateQuickReplies } from '../queries/useUpdateQuickReplies';

type Props = {
  renderCheckbox: boolean;
};

export const useQuickRepliesContentTable = ({ renderCheckbox }: Props) => {
  const { isPending: isLoadingCreateQuickReply, mutate: createQuickReply } = useCreateQuickReplies();
  const { data: quickReplies, isLoading, refetch: refetchQuickReplies } = useQuickReplies();
  const { isPending: isLoadingUpdateQuickReply, updateQuickReply } = useUpdateQuickReplies();

  const { deleteSelectedQuickReplies, isPending: isLoadingDeleteQuickReplies } = useDeleteQuickReplies();

  const [state, setState] = useState<IndexableQuickReply[]>([]);

  useEffect(() => {
    setState(quickReplies?.map(mapQuickRepliesToIndexableQuickReplies) ?? []);
  }, [quickReplies]);

  const table = useQuickReplyTable({
    data: state,
    renderCheckbox,
  });

  const itemsToDelete = table.getSelectedRowModel().rows.map(({ id }) => id);

  const deleteQuickReplies = async () => {
    await deleteSelectedQuickReplies(itemsToDelete);
    table.resetRowSelection();
    await refetchQuickReplies();
  };

  return {
    createQuickReply,
    deleteQuickReplies,
    isLoading,
    isLoadingCreateQuickReply,
    isLoadingDeleteQuickReplies,
    isLoadingUpdateQuickReply,
    itemsToDelete,
    quickReplies: state,
    table,
    updateQuickReply: async (quickReply: QuickReply) => {
      await updateQuickReply(quickReply);
    },
  };
};
